export enum VisualizerDurationResolution {
  EntireDuration = "EntireDuration",
}
